import * as AOS from "aos";

export namespace ScrollEffects {
    export const init = () => {
        let urlPath = window.location.pathname;

        if (!urlPath.includes('Sitefinity/adminapp')) {
            AOS.init({
                startEvent: 'load',
                once: true
            });
        }
    }
}